exports.Tagger = require('./POSTagger');
exports.Lexer = require('./lexer');



//////////////////
// WEBPACK FOOTER
// ../node_modules/pos/index.js
// module id = 230
// module chunks = 0